import React, { useContext, useEffect, useState } from "react";
import { Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import {
  task,
  task1,
  task2,
  task3,
  taskm,
  taskp,
  taskt,
  tasku,
} from "../iconsImports";
import InterviewCard from "./Biggbarains/InterviewCard";
import EmployeeChart from "./Biggbarains/EmployeeChart";
import EmployeeAvail from "./Biggbarains/EmployeeAvail";
import Applications from "./Biggbarains/Applications";
import Performer from "./Biggbarains/Performer";
import ProjectTable from "./Biggbarains/ProjectTable";
import AuthContext from "../store/AuthContext";
import ApiEndpoints from "../network/ApiEndPoints";
import { apiErrorToast } from "../utils/ToastUtil";
import { get } from "../network/ApiController";
import AttendanceEmpModal from "./Biggbarains/AttandanceEmpModal";
import MarkAttendanceModal from "./Biggbarains/MarkAttendanceModal";

export default function RetDdDashboard() {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
  const authCtx = useContext(AuthContext);
  const user = authCtx.user;
  const [data, setData] = useState(null);

  const [attendanceStatus, setAttendanceStatus] = useState(null);

  const getAttendanceStatus = () => {
    get(
      ApiEndpoints.GET_ATTENDANCE,
      "",
      () => {},
      (res) => {
        const lastRecord = res.data?.data?.data[0]; // API gives data.data
        console.log("Last Attendance Record:", lastRecord);
        if (lastRecord) {
          if (!lastRecord.in_selfie) {
            // 🟢 No selfie yet → show IN modal
            setAttendanceStatus("NEED_IN");
          } else {
            // 🔴 Selfie already present → no modal
            setAttendanceStatus("DONE");
          }
        } else {
          setAttendanceStatus("NEED_IN");
        }
      },
      (err) => {
        apiErrorToast(err);
      }
    );
  };

  const getDashBoardData = () => {
    get(
      ApiEndpoints.GET_DASHBOARD_DATA,
      "",
      () => {},
      (res) => {
        setData(res.data.data);
      },
      (err) => {
        apiErrorToast(err);
      }
    );
  };

  useEffect(() => {
    getDashBoardData();
    getAttendanceStatus();
  }, []);

  return (
    <Grid container spacing={3} padding={3} sx={{ mt: 1, pr: 0 }}>
      {(user.role === "Developer" ||
        user.role === "Trainee" ||
        user.role === "Backend") && (
        <>
          {attendanceStatus === "NEED_IN" && (
            <MarkAttendanceModal mode="in" autoOpen={true} />
          )}
        </>
      )}

      <Grid container spacing={3}>
        <Grid item xs={12} lg={12}>
          <Grid
            container
            spacing={2}
            direction="row"
            justifyContent="space-between"
          >
            <Grid item xs={12} md={6} lg={3}>
              <Applications
                numberOfInterviews={data?.tasks?.total || 0}
                title={
                  user.role === "Admin" || user.role === "Merchant"
                    ? "Total Tasks"
                    : "Assigned Tasks"
                }
                image={task}
              />
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <InterviewCard
                numberOfInterviews={data?.tasks?.details?.COMPLETED?.count || 0}
                title="Completed Tasks"
                image={task1}
                titleColor="#000"
              />
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <InterviewCard
                numberOfInterviews={
                  // data?.tasks?.details?.["In Progress"]?.count || 0
                  data?.tasks?.total - data?.tasks?.details?.COMPLETED?.count ||
                  0
                }
                title="Tasks in Progress"
                image={task3}
                titleColor="#000"
              />
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <InterviewCard
                numberOfInterviews={
                  user.role === "Admin"
                    ? data?.tasks?.details?.UNASSIGNED?.count || 0
                    : data?.tasks?.unassigned || 0
                }
                title="Unassigned Tasks"
                image={tasku}
                titleColor="#000"
              />
            </Grid>
          </Grid>
        </Grid>

        {user.role === "Admin" && (
          <Grid item xs={12}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={7}>
                <EmployeeAvail employeeData={data?.employee_availability} />
              </Grid>
              <Grid item xs={12} md={5}>
                <EmployeeChart
                  employeeData={data?.role?.details || {}} // Pass the details from the API response
                />
              </Grid>
            </Grid>
          </Grid>
        )}

        <Grid item xs={12} lg={12}>
          <Grid
            container
            spacing={2}
            direction="row"
            justifyContent="space-between"
          >
            <Grid item xs={12} md={6} lg={4}>
              <InterviewCard
                numberOfInterviews={data?.projects?.total || 0}
                title="Total Projects"
                image={task1}
                backgroundColor="#2F3B57"
                titleColor="#fff"
                textColor="#fff"
              />
            </Grid>

            <Grid item xs={12} md={6} lg={4}>
              <InterviewCard
                numberOfInterviews={
                  data?.projects?.details?.["InProgress"]?.count || 0
                }
                title="Projects in Progress"
                image={task2}
                backgroundColor="#2F3B57"
                titleColor="#fff"
                textColor="#fff"
              />
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <InterviewCard
                numberOfInterviews={
                  data?.projects?.details?.["Maintenance"]?.count || 0
                }
                title="Maintenance"
                image={taskm}
                backgroundColor="#2F3B57"
                titleColor="#fff"
                textColor="#fff"
              />
            </Grid>
          </Grid>
        </Grid>

        {user.role === "Admin" && (
          <Grid item xs={12}>
            <Performer />
          </Grid>
        )}
        {/* {user.role === "Admin" && (
          <Grid item xs={12}>
            <ProjectTable />
          </Grid>
        )} */}
      </Grid>
    </Grid>
  );
}
